export const getGeoArrayFromObject = (location: { lat: string; lng: string }) => [
    Number(location.lng),
    Number(location.lat)
];
